import styled from '@emotion/styled';
import { Button } from "@edusense/shared-ui-kit";

// 메인 페이지 컨테이너
export const HomeContainer = styled.div`
  padding-bottom: 4rem; /* pb-16 */
  
  @media (min-width: 768px) {
    padding-bottom: 0; /* md:pb-0 */
  }
`;

// 알림 컨테이너
export const InfoContainer = styled.div`
  padding: 1rem; /* p-4 */
  background-color: #eff6ff; /* bg-blue-50 */
  border-bottom: 1px solid #e5e7eb; /* border-b border-gray-200 */
`;

// 알림 내용 레이아웃
export const InfoContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

// 알림 텍스트 영역
export const InfoTextContainer = styled.div``;

// 알림 제목
export const InfoTitle = styled.h3`
  font-weight: 700; /* font-bold */
  font-size: 0.875rem; /* text-sm */
`;

// 알림 설명
export const InfoDescription = styled.p`
  font-size: 0.875rem; /* text-sm */
  color: #4b5563; /* text-gray-600 */
  margin-top: 0.25rem; /* mt-1 */
`;

// 알림 닫기 버튼 - Button 컴포넌트 그대로 사용 (styled() 래핑 안함)
export { Button as CloseButton };

// 피드 리스트 컨테이너
export const FeedList = styled.div``;

// 닫기 아이콘
export const CloseIcon = styled.svg`
  height: 1.25rem; /* h-5 */
  width: 1.25rem; /* w-5 */
`; 